<template>
  <Spinner :loading="loading">
    <div :class="$style.wrapper">
      <Button :class="$style.button" type="submit" @click="open">
        {{buttonText}}
      </Button>
<!--      <template v-if="!sent">-->
<!--        <input type="text" required :class="[$style.input, { [$style.error]: error }]" v-model="name" placeholder="Твое имя">-->
<!--        <input type="email" required :class="[$style.input, { [$style.error]: error }]" v-model="email" placeholder="Email">-->
<!--        <Button :class="$style.button" type="submit" @click="submit">-->
<!--          {{buttonText}}-->
<!--        </Button>-->
<!--      </template>-->
<!--      <h1 :class="$style.sent" v-else>Ваш сертификат отправлен!</h1>-->
    </div>
  </Spinner>
</template>
<script>
import Button from '@/components/@ui/Button/Button.vue'
import Spinner from '@/components/@ui/Spinner/Spinner.vue'

// eslint-disable-next-line no-useless-escape
const EMAIL_REGEX = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i

export default {
  name: 'Certificate',
  components: { Button, Spinner },
  data: () => ({
    name: '',
    email: '',
    error: false,
    loading: false,
    sent: false,
  }),
  watch: {
    name() {
      this.error = false
    },
    email() {
      this.error = false
    },
    sent(sent) {
      if (sent) {
        setTimeout(() => {
          this.sent = false
        }, 3000)
      }
    },
  },
  methods: {
    submit() {
      this.error = false
      const { name, email } = this
      if (name.length < 3 || (email.length > 0 && !EMAIL_REGEX.test(email))) {
        this.error = true
        return
      }
      if (email.length === 0) {
        this.downloadCertificate()
        return
      }
      this.loading = true
      this.$store.dispatch('sendCertificate', { name, email })
        .then(() => {
          this.sent = true
          this.name = ''
          this.email = ''
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadCertificate() {
      const { name } = this
      const { userID } = this.$store.state
      window.open(`https://form.datalesson.ru/api/v1/certificates/student/${userID}?name=${name}`, '_blank')
    },
    open() {
      window.open('https://урокцифры.рф/certificate/bolshie-dannye/', '_blank')
    },
  },
  computed: {
    buttonText() {
      if (this.email.length === 0) {
        return 'Скачать сертификат'
      }
      return 'Получить на почту'
    },
  },
}
</script>
<style lang="scss" module>
@import './Certificate.scss';
</style>
